import style from "./EuFunding.module.css";

import fundedByEu from "@/assets/images/funded-EU.jpg";

// Fixed by the EU's visibility rules — it stays in English on a site that is
// otherwise in Bosnian, and must not be paraphrased or translated.
const FUNDING_STATEMENT =
	"Funded by the European Union. The views and opinions expressed are, however, those of the author(s) only and do not necessarily reflect those of the European Union. The European Union cannot be held responsible for them.";
// The alt mirrors the English text inside the official EU lockup image, so it
// stays English in both languages. It is deliberately a plain constant rather
// than a t() key, which also keeps it outside the i18next/no-literal-string
// lint rule. The login page uses the same image and imports this constant.
export const FUNDING_ALT = "Funded by the European Union";

/**
 * EU funding attribution: the official black "Funded by the European Union"
 * lockup, the same file the login page already uses, blended onto whatever
 * surface it sits on so it carries no white plate of its own.
 *
 * `statement` adds the full disclaimer under it, for the pages of courses the
 * funding paid for. Without it the lockup stands alone, for the footer.
 *
 * The height is set in real centimetres because that is how the requirement
 * reads — the flag must be displayed at 2cm or more. In this lockup the flag
 * is 92% of the image's height, so 2.2cm leaves the flag itself just over the
 * minimum, and it only scales down where the column is narrower than the
 * lockup is wide.
 */
function EuFunding({ statement = false, className = "" }) {
	const logo = (
		<img className={style.lockup} src={fundedByEu} alt={FUNDING_ALT} />
	);

	if (statement) {
		return (
			<div className={`${style.statement} ${className}`}>
				{logo}
				<p className={style.statementText}>{FUNDING_STATEMENT}</p>
			</div>
		);
	}

	return <div className={className}>{logo}</div>;
}

export default EuFunding;
